<template>
    <section class="px-content py-10 xl:py-[60px]  will-change" :data-scroll-section="inner == 'false'">
        <div class="flex flex-col xl:flex-row items-center py-20 px-10 xl:px-desk" :class="computedClass">
            <div class="xl:w-3/12">
                <div class="tracking-desk text-sm mb-4 leading-5 uppercase text-navy-blue-03" v-show="blockData.kicker">{{ blockData.kicker }}</div>
                <h2 class="text-4xl xl:text-heading text-center xl:text-left mb-8 xl:mb-0"
                    :class="{
                        'text-navy-blue-01': blockData.background_color === 'Light Blue',
                        'text-navy-blue-01': blockData.background_color === 'White',
                        'text-white' : blockData.background_color === 'Dark Blue'
                    }"
                    v-show="blockData.title">{{ blockData.title }}</h2>
            </div>

            <div class="text-center xl:text-left md:mx-auto w-full xl:w-4/12" v-show="blockData.text" v-html="blockData.text"></div>

            <template v-if="blockData.background_color === 'Light Blue' || blockData.background_color === 'White'">
                <a class="btn mt-8 xl:mt-0 self-center" v-show="blockData.cta" :href="blockData.cta.url">
                    {{ blockData.cta.title }}
                    <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square"/>
                    </svg>
                </a>
            </template>
            <template v-else>
                <a class="btn btn-clean  mt-8 xl:mt-0 self-center" v-show="blockData.cta" :href="blockData.cta.url">
                    {{ blockData.cta.title }}
                    <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12L21 12" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M18 8L22 12L18 16" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                    </svg>
                </a>
            </template>

        </div>
    </section>
</template>


<script>
    export default {
        name: 'CtaBar',
        data() {
            return {}
        },
        mounted() {

        },
        computed: {
            computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'Light Blue' ) {
                    className = [
                        'bg-light-blue-03',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'White' ) {
                    className = [
                        'bg-white',
                        'text-navy-blue-02'
                    ]
                }
                if ( this.blockData.background_color === 'Dark Blue' ) {
                    className = [
                        'bg-navy-blue-01',
                        'text-white'
                    ]
                }
                return className;
            }
        }
    }
</script>
